/**
 * アンカーリンクのアクティブ状態管理クラス
 * .js-anchor-sectionがページの上部10vhに入ったら
 * 同じidへアンカーリンクする.js-anchor-linkに.is-activeを付け替える
 */
export default class AnchorManager {
  constructor() {
    this.sections = document.querySelectorAll('.js-anchor-section');
    this.links = document.querySelectorAll('.js-anchor-link');
    this.activeClass = 'is-active';
    
    this.init();
  }

  /**
   * 初期化処理
   */
  init() {
    if (this.sections.length === 0 || this.links.length === 0) {
      return;
    }

    this.setupIntersectionObserver();
  }

  /**
   * Intersection Observerの設定
   */
  setupIntersectionObserver() {
    // ビューポートの高さの10%をピクセル値で計算
    const viewportHeight = window.innerHeight;
    const topMargin = Math.round(viewportHeight * 0.1); // 10vhをピクセルに変換
    const bottomMargin = Math.round(viewportHeight * 0.4); // 90vhをピクセルに変換
    
    const options = {
      root: null,
      rootMargin: `-${topMargin}px 0px -${bottomMargin}px 0px`,
      threshold: 0
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.setActiveLink(entry.target);
        }
      });
    }, options);

    // 各セクションを監視対象に追加
    this.sections.forEach(section => {
      this.observer.observe(section);
    });
  }

  /**
   * アクティブなリンクを設定
   * @param {Element} activeSection - アクティブになったセクション
   */
  setActiveLink(activeSection) {
    // 全てのリンクからアクティブクラスを削除
    this.links.forEach(link => {
      link.classList.remove(this.activeClass);
    });

    // アクティブなセクションのIDに対応するリンクを探す
    const sectionId = activeSection.id;
    if (sectionId) {
      const targetLink = document.querySelector(`.js-anchor-link[href="#${sectionId}"]`);
      if (targetLink) {
        targetLink.classList.add(this.activeClass);
      }
    }
  }

  /**
   * オブザーバーを破棄
   */
  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
